import {selectIsPremium as selectIsEviteEventPremium} from './eviteEvent';

export const selectEventDetails = ({eventDetails}) => eventDetails;
export const selectGuestsOfHonor = (state) => selectEventDetails(state)?.guestsOfHonor ?? [];
export const selectHostName = (state) => selectEventDetails(state)?.host_name ?? '';
export const selectIsPremium = (state) =>
  selectEventDetails(state)?.isPremium || selectIsEviteEventPremium(state).isPremium;
export const selectRegistriesData = (state) => selectEventDetails(state).registriesData ?? false;
